import React, { Component, } from 'react'

import {images, colors, CCActivityIndicator, CCAppEventLogger, strings} from './../../cc-imports'

import PropTypes from 'prop-types';
// import './cc-button.css'
// import './cc-button-320x720.css'

import './../../styles/css/components/CCButton/cc-button.css'

class CCButton extends Component {

    static propTypes = {
        backgroundColor: PropTypes.string,
        fontFamily: PropTypes.string,
        fontWeight: PropTypes.string,

        iconClassName : PropTypes.string,
        className : PropTypes.string,

        height : PropTypes.number,

        loading: PropTypes.bool,
        onPress: PropTypes.func,

        successMessage: PropTypes.string,
        success: PropTypes.bool,
        type : PropTypes.string,

        borderWidth: PropTypes.number,
        borderColor: PropTypes.string,

        title: PropTypes.string,
        fontColor: PropTypes.string,
        titleSize: PropTypes.number,
        disabled: PropTypes.bool,
        titleClassName : PropTypes.string,

        analytics: PropTypes.object,
        darkBackgroundColor:PropTypes.string,
        darkFontColor: PropTypes.string
    }

    static defaultProps = {
        backgroundColor: colors.theme2.bg_color1,
        fontFamily: "Montserrat",
        fontWeight: "normal",
        iconClassName : '',
        className : '',

        height : 50,
        loading: false,
        onPress: ()=> {
        },
        successMessage: '',
        success: false,
        type : 'default',
        title: 'Button',
        fontColor: colors.theme2.font_color4,
        titleSize: 18,
        titleClassName:'',
        disabled: false,

        theme : 'default',
        darkBackgroundColor:colors.theme2.bg_color8 ,
        darkFontColor: colors.theme2.font_color3,

    }

    constructor(props) {
        super(props)
        this.state = {
            showModal: false
        }
        this._onPressed = this._onPressed.bind(this);

        this._getIcon=this._getIcon.bind(this);
        this._getBgColor=this._getBgColor.bind(this);
        this._getBorderColor=this._getBorderColor.bind(this);
        this._getFontColor=this._getFontColor.bind(this);
        this._getTitle=this._getTitle.bind(this);
    }

    componentWillReceiveProps(props) {
        if (this.props.success != true && props.success == true) {
            this.setState({showModal: true});
            this.setTimeout(() => {
                this.setState({showModal: false});
            }, 1000);
        }
    }

    _onPressed() {
        const {analytics} = this.props;
        if (analytics) {
            const {event, params}=analytics;
            CCAppEventLogger.logAppEvent(event, params?params:{});
        }
        this.props.onPress();
    }

    _getTitle() {
        switch (this.props.type){
            case 'fb_signin':
                return  strings('fb_signin')
            case 'fb_signup':
                return strings('fb_signup')
                break;
            case 'ggl_signin':
                return  strings('ggl_signin')
                break;
            case 'ggl_signup':
                return strings('ggl_signup')
                break;
            case 'ggl_reauth':
                return strings('ggl_reauth')
                break;
            case 'fb_reauth':
                return strings('fb_reauth')
                break;
                break;
            default:
                return this.props.title
        }
    }

    _getIcon() {
        switch (this.props.type){
            case 'fb_signin':
            case 'fb_signup':
            case 'fb_reauth':
                return images.icons.old.fb_icon_160;
                break;
            case 'ggl_signin':
            case 'ggl_signup':
            case 'ggl_reauth':
                return images.icons.old.g_plus_icon_160;
                break;
            default:
                return this.props.icon
        }
    }

    _getBgColor () {
        switch (this.props.type){
            case 'fb_signin':
            case 'fb_signup':
            case 'ggl_signin':
            case 'ggl_signup':
            case 'fb_reauth':
            case 'ggl_reauth':
                return colors.theme.btn_bg_color1;
                break;
            case 'dark':
                return this.props.darkBackgroundColor;
                break;
            default:
                return this.props.backgroundColor
        }
    }

    _getBorderColor() {
        switch (this.props.type){
            case 'fb_signin':
            case 'fb_signup':
            case 'ggl_signin':
            case 'ggl_signup':
            case 'fb_reauth':
            case 'ggl_reauth':
                return this.props.borderColor
                break;
            default:
                return this.props.borderColor
        }
    }

    _getFontColor() {
        switch (this.props.type){
            case 'fb_signin':
            case 'fb_signup':
            case 'ggl_signin':
            case 'ggl_signup':
            case 'fb_reauth':
            case 'ggl_reauth':
                return colors.theme2.font_color4
                break;
            case 'dark':
                return this.props.darkFontColor;
                break;
            default:
                return this.props.fontColor
        }
    }


    render() {
        const {titleClassName, className, disabled} = this.props;
        return (
            <div style={{opacity:this.props.disabled?0.5:1}} className={'flex-container cc-btn '+ className +' '+ (disabled ?'disabled':'') + (' '+ this.props.type)}>
                {
                    this.props.loading == true ?
                        <CCActivityIndicator color={this._getFontColor()} size={"s"}></CCActivityIndicator>
                        :
                        <div className={'btn cc-button-width'} onClick={()=>{!disabled ? this._onPressed() : ''}} disabled={this.props.disabled}>
                            <div className={'flex-container cc-btn-inner'}>
                                {
                                    this._getIcon() != null &&
                                    <img src={this._getIcon()} className={'cc-btn-icon'} ></img>
                                }
                                <h3 className={'cc-btn-title '+ titleClassName} style={{fontFamily: this.props.fontFamily, fontWeight:this.props.fontWeight, color: this._getFontColor()}}>{this._getTitle()}</h3>
                            </div>
                        </div>
                }
            </div>
        );
    }
}


export default CCButton



// WEBPACK FOOTER //
// ./src/app/components/CCButton/CCButton.js